<template>
  <div>
    <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-light shadow-sm" >
      <div class="container-fluid">
        <a class="navbar-brand" href="../"><img src="../assets/img/logo.png" class="logo" :alt="constants.appName" /></a>
        <button class="navbar-toggler" type="button" aria-label="Toggle navigation" @click="openNav()" >
          <span class="navbar-toggler-icon">
            <i class="fas fa-bars" style="font-size: 28px"></i>
          </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li v-for="(x, idx) in menu_" :key="idx" class="nav-item">
              <router-link :to="'/' + x.link" :title="x.title">
                <span class="nav-link text-dark">
                  <icon :name="x.ico"></icon>
                  {{ x.title }}
                </span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="mySidenav" class="sidenav text-uppercase">
      <div>
        <a href="" title="Izbornik" class="font-weight-bold text-light" @click="closeNav()">Menu</a>
        <a href="" class="closebtn" @click="closeNav()" title="Zatvori" ><strong>&times;</strong></a>
        <hr class="m-0 mx-4 mb-2 bg-light" />
      </div>
      <div v-for="(x, idx) in menu_" :key="idx" @click="closeNav()">
        <router-link :to="'/' + x.link" :title="x.title">
          <span class="nav-link">
            <icon :name="x.ico"></icon>
            {{ x.title }}
          </span>
        </router-link>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      menu: [
        { link: "", title: "Naslovna", ico: null, isVisible: true },
        { link: "o-nama", title: "O nama", ico: null, isVisible: true },
        { link: "usluge", title: "Usluge", ico: null, isVisible: true },
        { link: "portfolio", title: "Portfolio", ico: null, isVisible: false },
        { link: "cijene", title: "Cijene", ico: null, isVisible: true },
        { link: "kontakt", title: "Kontakt", ico: null, isVisible: true },
        { link: "test", title: "Test", ico: null, isVisible: false },
      ],
      constants: this.$constants,
    };
  },
  computed: {
    menu_: function () {
      return this.menu.filter((a) => a.isVisible);
    },
  },
  methods: {
    openNav() {
      if (document.getElementById("mySidenav").style.width == "250px") {
        document.getElementById("mySidenav").style.width = "0";
      } else {
        document.getElementById("mySidenav").style.width = "250px";
      }
    },
    closeNav() {
      document.getElementById("mySidenav").style.width = "0";
      window.scrollTo({ top: 340, behavior: 'smooth' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cNavbar.vue